import React from 'react'
import { useTheme } from '@emotion/react'
import  BaseUITag  from '../base-ui/Tag'

function Tag({ children, href, rounded, closeBtn }) {
    const theme = useTheme()
    const style = `
        color: ${theme.colors.white};
        a {
            color: ${theme.colors.white};
        }
        border-radius: 0;
        background-color: ${theme.colors.primary};
        &:hover {
            background-color: ${theme.colors.secondary};
            a {
                color: ${theme.colors.white};
            }
        }
    `
    return (
        <BaseUITag style={style} href={href} rounded={rounded} closeBtn={closeBtn}>
            {children}
        </BaseUITag>
    )
}

export default Tag